<template>
        <div class="page-header">
            <div class="header-content">
                <div class="header-main">
                    <div class="breadcrumbs" v-if="breadcrumbs && breadcrumbs.length > 0">
                        <router-link v-for="(crumb, index) in breadcrumbs" :key="crumb.path" :to="crumb.path"
                            class="breadcrumb-link" :class="{ 'current': index === breadcrumbs.length - 1 }">
                            {{ crumb.label }}
                            <i v-if="index < breadcrumbs.length - 1" class="bi bi-chevron-right"></i>
                        </router-link>
                    </div>

                    <div class="title-section">
                        <h1 class="page-title">{{ title }}</h1>
                        <p v-if="subtitle" class="page-subtitle">{{ subtitle }}</p>
                    </div>

                    <div v-if="action" class="header-actions">
                        <button class="header-action-btn" @click="action.handler">
                            <i class="bi" :class="`bi-${action.icon}`"></i>
                            {{ action.label }}
                        </button>
                    </div>
                </div>

                <div v-if="additionalInfo" class="additional-info">
                    <slot name="additional"></slot>
                </div>
            </div>
        </div>
</template>

<script setup>

//eslint-disable-next-line
defineProps({
    title: {
        type: String,
        required: true,
        default: "LGU Palompon"
    },
    subtitle: String,
    breadcrumbs: Array,
    action: Object,
    additionalInfo: Boolean
});
</script>

<style scoped>
.page-header {
    background: linear-gradient(135deg, #8b0000 0%, #b71c1c 100%);
    color: white;
    padding: 2rem;
    border-bottom: 1px solid #d32f2f;
    box-shadow: 0 4px 20px rgba(183, 28, 28, 0.2);
}

.header-content {
    max-width: 1400px;
    margin: 0 auto;
}

.header-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 2rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}

.breadcrumbs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    font-size: 0.9rem;
    width: 100%;
    margin-bottom: 1rem;
}

.breadcrumb-link {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: color 0.3s ease;
}

.breadcrumb-link:hover:not(.current) {
    color: white;
    text-decoration: underline;
}

.breadcrumb-link.current {
    color: white;
    font-weight: 600;
    pointer-events: none;
}

.breadcrumb-link i {
    font-size: 0.8rem;
    opacity: 0.7;
}

.title-section {
    flex: 1;
    min-width: 300px;
}

.page-title {
    font-size: 2rem;
    font-weight: 700;
    margin: 0 0 0.5rem 0;
    color: white;
    line-height: 1.2;
}

.page-subtitle {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
    line-height: 1.5;
}

.header-actions {
    display: flex;
    align-items: center;
}

.header-action-btn {
    background: rgba(255, 255, 255, 0.15);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    padding: 0.75rem 1.5rem;
    border-radius: 10px;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    backdrop-filter: blur(10px);
}

.header-action-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.additional-info {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

@media (max-width: 768px) {
    .page-header {
        padding: 1.5rem 1rem;
    }

    .header-main {
        flex-direction: column;
        gap: 1rem;
    }

    .title-section {
        min-width: 100%;
    }

    .page-title {
        font-size: 1.75rem;
    }

    .header-actions {
        width: 100%;
    }

    .header-action-btn {
        width: 100%;
        justify-content: center;
    }
}
</style>